import "core-js/modules/es.array.concat.js";
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
export var getManagementCompanyIconUrl = function getManagementCompanyIconUrl(managementCompany) {
  if (managementCompany.organization) {
    if (managementCompany.isPartner) return "".concat(getSuperPartnerBaseURL(), "/image/").concat(managementCompany.organization.icon);
    return "/image/".concat(managementCompany.organization.icon);
  }
  return null;
};